import {Box, Button, styled, Typography} from "@mui/material";
import React from "react";
import contactsBackground from "../../assets/contactsBackground.png";
import contactsGif from "../../assets/contactsGif.gif";
import EmailIcon from "@mui/icons-material/Email";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import TelegramIcon from "@mui/icons-material/Telegram";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";

const ContactsContainer = styled(Box)({
    padding: "10px 20px",
    boxSizing: "border-box",
    borderImage: "linear-gradient(90deg, #05080c, #6d7985, #05080c) 100",
    borderBottom: "2px solid",
    display: "grid",
    gridTemplateColumns: "1fr 2fr",
    background: `url(${contactsBackground}) no-repeat center 100%`,
    backgroundSize: "cover",
    "& ul":{
        "@media(max-width: 768px)":{
            padding: 0,
        },
    },
    "& li":{
        display: "grid",
        width: "max-content",
        gridTemplateColumns: "200px auto",
        alignItems: "center",
        gap: "20px",
        marginTop: "10px",
        fontSize: "1.3rem",
        fontWeight: 200,
        color: "#FFFFFF",
        zIndex: 2,
        textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
        "@media(max-width: 768px)":{
            gridTemplateColumns: "20vw auto",
            fontSize: "1rem",
        },
    },
    "@media(max-width: 768px)":{
        gridTemplateColumns: "1fr",
    },
});

export const Title = styled(Typography)({
    marginLeft: "20px",
    fontSize: "3.5rem",
    fontWeight: 400,
    color: "#FFFFFF",
    zIndex: 2,
    textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
    "@media(max-width: 768px)":{
        fontSize: "1.8rem",
    },
});

const ContactsButton = styled(Button)({
    background: "#FFFFFF",
    color: "#000000",
    display: "flex",
    gap: "10px",
    alignItems: "center",
    textDecoration: "none",
    textShadow: "none",
    transition: "background 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55), transform 0.3s ease-out",
    "&:hover":{
        background: "#ffffff",
        boxShadow:"0 0 15px #ffc371",
        transform: "scale(1.05)",
    },
    "@media(max-width: 400px)":{
        fontSize: "0.6rem",
    },
});

const ContactsContainerEls = styled(Box)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    "@media(max-width: 768px)":{
        gridTemplateColumns: "1fr",
    },
});

const Contacts = ():JSX.Element => {
    return (
        <ContactsContainer id={"contacts"}>
            <Box>
                <img src={contactsGif} alt={"contacts_gif"} width={"100%"} height={"auto"}/>
            </Box>
            <Box>
                <Title>Contacts:</Title>
                <ContactsContainerEls>
                    <ul>
                        <li>
                        Email:
                            <ContactsButton  onClick={() => window.open("mailto:nickpletnev@mail.ru")}>
                                <EmailIcon htmlColor={"#000000"}/>
                                nickpletnev@mail.ru
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                        <li>
                        Phone(EU):
                            <ContactsButton onClick={() => window.open("tel:+358406261070")}>
                                <LocalPhoneIcon htmlColor={"#000000"}/>
                            +358 406 261070
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                        <li>
                        Phone(UAE):
                            <ContactsButton onClick={() => window.open("tel:+971522825381")}>
                                <LocalPhoneIcon htmlColor={"#000000"}/>
                            +971 522 82 53 81
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                        <li>
                            Business ID(Finland):
                            <ContactsButton  onClick={() => window.open("https://tietopalvelu.ytj.fi/yritys/3480071-9")}>
                                <BusinessCenterIcon htmlColor={"#000000"}/>
                                3480071-9
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                    </ul>
                    <ul>
                        <li>LinkedIn:
                            <ContactsButton  onClick={() => window.open("https://www.linkedin.com/company/insight-questor/")}>
                                <LinkedInIcon htmlColor={"#000000"}/>
                                Company on LinkedIn
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                        <li>
                            <span/>
                            <ContactsButton  onClick={() => window.open("https://www.linkedin.com/in/nikita-pletnev-421b14178/")}>
                                <LinkedInIcon htmlColor={"#000000"}/>
                                Me on LinkedIn
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                        <li>GitHub:
                            <ContactsButton  onClick={() => window.open("https://github.com/NikitaPletnev")}>
                                <GitHubIcon htmlColor={"#000000"}/>
                                Me on GitHub
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                        <li>Telegram:
                            <ContactsButton  onClick={() => window.open("https://t.me/Nick_pletnev")}>
                                <TelegramIcon htmlColor={"#000000"}/>
                            Me on Telegram
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                        <li>Schedule Meeting:
                            <ContactsButton  onClick={() => window.open("https://calendly.com/nikita_pletnev/1-hour-meeting")}>
                                <EventAvailableIcon htmlColor={"#000000"}/>
                            Calendly
                                <DoubleArrowIcon htmlColor={"#000000"}/>
                            </ContactsButton>
                        </li>
                    </ul>
                </ContactsContainerEls>
            </Box>
        </ContactsContainer>
    );
};

export default Contacts;
